import axios from 'axios'
import config from '../../config'
import { IArticle } from '../article/types/IArticle'

export const fetchArticlesBySearch = async (params: { publisherKey: string; text: string }): Promise<IArticle[]> => {
    const publisherKey = `publisherKey=${params.publisherKey}`
    const text = `&text=${params.text}`

    const response = await axios.get(`${config.apiEndpoint}/v4/discovery/search/embed?${publisherKey}${text}`)

    if (response && response.data && response.data.data) {
        return response.data.data
    }

    throw new Error('Articles could not be fetched')
}
